module.exports = "<template> <video-reference-input field.bind=field value.bind=field.value></video-reference-input> </template> ";